/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_InstallInputs */

const en_push_install = /** @type {(inputs: Push_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On iPhone and iPad, add the app to your Home Screen first (Share, then Add to Home Screen), open it from there and turn notifications on.`)
};

/**
* | output |
* | --- |
* | "On iPhone and iPad, add the app to your Home Screen first (Share, then Add to Home Screen), open it from there and turn notifications on." |
*
* @param {Push_InstallInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_install = /** @type {((inputs?: Push_InstallInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_InstallInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_install(inputs)
});